/**
 * Checks if all cart items are digital delivery (no shipping required)
 * @param {Array} cartItems - Array of cart item objects
 * @returns {boolean}
 */
export const isAllDigitalDelivery = cartItems => {
  if (!cartItems || cartItems.length === 0) return false
  return cartItems.every(item => item.shippable_type === 'Digital Delivery')
}

/**
 * Checks if each cart item has a multi-address selection
 * @param {Array} cartItems - Array of cart item objects
 * @param {Array} multiAddressSelection - Array of multi-address selections
 * @returns {boolean}
 */
export const hasMultiAddressSelections = (cartItems, multiAddressSelection) => {
  if (!cartItems || cartItems.length === 0) return true
  if (!multiAddressSelection || multiAddressSelection.length === 0) return false

  const selectedCartItemIds = multiAddressSelection.map(s => s.cartItemId)
  return cartItems.every(item => selectedCartItemIds.includes(item.cart_item_id))
}

/**
 * Gets cart items that are missing multi-address selections
 * @param {Array} cartItems - Array of cart item objects
 * @param {Array} multiAddressSelection - Array of multi-address selections
 * @returns {Array} - Cart items without selections
 */
export const getCartItemsMissingSelections = (cartItems, multiAddressSelection) => {
  if (!cartItems || cartItems.length === 0) return []
  if (!multiAddressSelection || multiAddressSelection.length === 0) return cartItems

  const selectedCartItemIds = multiAddressSelection.map(s => s.cartItemId)
  return cartItems.filter(item => !selectedCartItemIds.includes(item.cart_item_id))
}

/**
 * Checks if cart has any shippable items (non-digital)
 * @param {Array} cartItems - Array of cart item objects
 * @returns {boolean}
 */
export const hasShippableItems = cartItems => {
  if (!cartItems || cartItems.length === 0) return false
  return cartItems.some(item => item.shippable_type !== 'Digital Delivery')
}

